module.exports = __webpack_public_path__ + "static/img/product-13.a8e6ef1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-13.png
// module id = hdgP
// module chunks = 0